import { combineReducers } from 'redux';

/**
 * @name The State App Reducer
 * @module reducers/app
 * @example {
 *  ["routeNameOrResourceName"]:{
 *     ["actionOrKeyName"]:{},
 *     ["show"]:{},
 * }
 */
// Client State
const INITIAL_STATE = {};

const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  const matches = /(RESOURCE)>(.*)>(.*)/.exec(type);
  // not a *_REQUEST / *_SUCCESS /  *_FAILURE actions, so we ignore them
  if (!matches) return state;
  const [, , resourceName, actionName] = matches;
  const resource = state[resourceName] || {};

  return {
    ...state,
    [resourceName]: {
      ...resource,
      [actionName]: payload,
    },
  };
};

const AppReducer = combineReducers({
  resource: reducer,
});

export default AppReducer;
